var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10847_34543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 2.5C14.4935 2.5 18.2319 5.73333 19.016 10C18.2327 14.2667 14.4935 17.5 10.0002 17.5C5.50687 17.5 1.76854 14.2667 0.984375 10C1.76771 5.73333 5.50687 2.5 10.0002 2.5ZM10.0002 15.8333C11.6998 15.833 13.3489 15.2557 14.6776 14.196C16.0063 13.1363 16.936 11.6569 17.3144 10C16.9346 8.34442 16.0043 6.86667 14.6757 5.80835C13.3471 4.75004 11.6988 4.17377 10.0002 4.17377C8.30162 4.17377 6.65328 4.75004 5.32469 5.80835C3.99609 6.86667 3.06585 8.34442 2.68604 10C3.06445 11.6569 3.9941 13.1363 5.32283 14.196C6.65155 15.2557 8.30065 15.833 10.0002 15.8333V15.8333ZM10.0002 13.75C9.00565 13.75 8.05182 13.3549 7.34856 12.6516C6.6453 11.9484 6.25021 10.9946 6.25021 10C6.25021 9.00544 6.6453 8.05161 7.34856 7.34835C8.05182 6.64509 9.00565 6.25 10.0002 6.25C10.9948 6.25 11.9486 6.64509 12.6519 7.34835C13.3551 8.05161 13.7502 9.00544 13.7502 10C13.7502 10.9946 13.3551 11.9484 12.6519 12.6516C11.9486 13.3549 10.9948 13.75 10.0002 13.75ZM10.0002 12.0833C10.5527 12.0833 11.0826 11.8638 11.4733 11.4731C11.864 11.0824 12.0835 10.5525 12.0835 10C12.0835 9.44747 11.864 8.91756 11.4733 8.52686C11.0826 8.13616 10.5527 7.91667 10.0002 7.91667C9.44767 7.91667 8.91777 8.13616 8.52707 8.52686C8.13637 8.91756 7.91687 9.44747 7.91687 10C7.91687 10.5525 8.13637 11.0824 8.52707 11.4731C8.91777 11.8638 9.44767 12.0833 10.0002 12.0833Z",
    fill: "#C2C2C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10847_34543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.18238cc101a5c4b0a2cabfa24004c6fd.svg";
export { ForwardRef as ReactComponent };